(function () {
  function initTshFrame() {
    var frame = document.querySelector('[data-tsh-frame]');
    var drawer = document.querySelector('[data-tsh-drawer]');
    var openBtn = document.querySelector('[data-tsh-drawer-open]');
    var closeBtn = document.querySelector('[data-tsh-drawer-close]');

    if (!frame || !drawer || !openBtn || !closeBtn) return;
    if (frame.dataset.tshFrameBound === 'true') return;

    frame.dataset.tshFrameBound = 'true';

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('tsh-drawer-open');
      closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('tsh-drawer-open');
      openBtn.focus();
    }

    openBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTshFrame);
  } else {
    initTshFrame();
  }

  document.addEventListener('shopify:section:load', initTshFrame);
})();